function isTruncatedByElement(element) {
  // Check if content is truncated horizontally
  var isWidthTruncated = element.scrollWidth > element.clientWidth;

  // Check if content is truncated vertically
  var isHeightTruncated = element.scrollHeight > element.clientHeight;
  return isWidthTruncated || isHeightTruncated;
}

// Use this method if we want a more precise calculation of if element is truncated with a given tolerance
// Use only for calculating truncation for single line cases to avoid issues related to height calculations for multi-line cases
function isTruncatedByBoundingRect(element) {
  var tolerance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var range = document.createRange();
  range.selectNodeContents(element);
  var contentRect = range.getBoundingClientRect();
  var containerRect = element.getBoundingClientRect();
  return contentRect.height - containerRect.height > tolerance || contentRect.width - containerRect.width > tolerance;
}
function isTextTruncated(element, isSingleLine) {
  return isSingleLine ? isTruncatedByBoundingRect(element) : isTruncatedByElement(element);
}

export { isTextTruncated as default };
//# sourceMappingURL=is-text-truncated.esm.js.map
